import React from "react";
import { Card, Descriptions, PageHeader } from "antd";

export const ViewAadharData = (props) => {
  console.log("props", props);

  return (
    <div id="view-profile">
      <div style={{ padding: "20px 0" }}>
        <PageHeader onBack={false} title="Aadhar Details">
          <Card className="viewCard">
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Aadhaar Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.aadhaar_number
                    ? props?.data?.aadhaar_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Age Range</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.age_range
                    ? props?.data?.age_range
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Gender</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.gender
                    ? props?.data?.gender == "F"
                      ? "Female"
                      : "Male"
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Is Mobile</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.is_mobile
                    ? props?.data?.is_mobile
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Last 3 Digits</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.last_digits
                    ? props?.data?.last_digits
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">State</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.state ? props?.data?.state : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Remarks</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.remarks
                    ? props?.data?.remarks
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Less Info</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.less_info
                    ? props?.data?.less_info
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Reason</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.type ? props?.data?.type : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Details</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.details
                    ? props?.data?.details
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </PageHeader>
      </div>
    </div>
  );
};
